import { defineStore } from 'pinia'
import axios from 'axios'
import { useLoaderStore } from './LoaderStore'

export const useUserStore = defineStore('UserStore', {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_ADDRESS,
    loaderStore: useLoaderStore(),
    selectedFactory: null,
    user: (() => {
      const stored = localStorage.getItem('user')
      return stored && stored !== 'undefined' ? JSON.parse(stored) : {}
    })(),
    factories: (() => {
      const stored = localStorage.getItem('factories')
      return stored && stored !== 'undefined' ? JSON.parse(stored) : []
    })(),

    //factories: [],
    count: 2,
  }),
  
  getters: {
    doubleCount: (state) => state.count * 2,
    apiUrl1: (state) => state.apiUrl
  },
  
  actions: {

    

    async updateFactory(factory) {
      
      this.preAction()
      try {
        console.log('addFactory')  
        const response = await axios.post(this.apiUrl + 'user/updateFactory', factory, {
          headers: {
            'sessionId': this.user.sessionId || ''
          }
        })
        this.factories = response.data.factories
        // Save to localStorage
        localStorage.setItem('factories', JSON.stringify(this.factories))

      } catch (error) {
        alert(error.message)
        this.error = error.message
      } finally {
        this.postAction()
      }
    },


    async addFactory(factory) {
      
      this.preAction()
      try {
        console.log('addFactory')  
        const response = await axios.post(this.apiUrl + 'user/addFactory', factory, {
          headers: {
            'sessionId': this.user.sessionId || ''
          }
        })
        this.factories = response.data.factories
        // Save to localStorage
        localStorage.setItem('factories', JSON.stringify(this.factories))

      } catch (error) {
        alert(error.message)
        this.error = error.message
      } finally {
        this.postAction()
      }
    },


    async getFactories() {
      
      this.preAction()
      try {
        console.log('getFactories')  
        const response = await axios.post(this.apiUrl + 'user/getFactories', null,{
          headers: {
            'sessionId': this.user.sessionId || ''
          }
        })
        this.factories = response.data.factories
        // Save to localStorage
        localStorage.setItem('factories', JSON.stringify(this.factories))
          
      } catch (error) {
        //if (error.response && error.response.status === 500) {
          alert(error.response.data.message);
          // Redirect to login page or show login modal
        //}
        //alert(error.message)
        this.error = error.message
      } finally {
        this.postAction()
      }
    },

    async login(credentials) {
      this.preAction()
      try {
        console.log('login')  
        const response = await axios.post(this.apiUrl + 'user/login', credentials)
        this.user = response.data.user
        
        // Save to localStorage
        localStorage.setItem('user', JSON.stringify(this.user))
        
      } catch (error) {
        alert(error.response.data.message)
        this.error = error.response.data.message
      } finally {
        this.postAction()
      }
    },

    logout() {
      this.user = {}
            // Clear localStorage
      localStorage.removeItem('user')
    },

    async updateProfile(profileData) {
      this.preAction()
      try {
        console.log('updateProfile')
        const response = await axios.post(this.apiUrl + 'user/updateProfile', profileData, {
          headers: {
            'sessionId': this.user.sessionId || ''
          }
        })
        // Update user data
        this.user = { ...this.user, ...response.data.user }
        // Save to localStorage
        localStorage.setItem('user', JSON.stringify(this.user))
      } catch (error) {
        alert(error.response?.data?.message || error.message)
        this.error = error.response?.data?.message || error.message
        throw error
      } finally {
        this.postAction()
      }
    },

    async changePassword(currentPassword, newPassword) {
      this.preAction()
      try {
        console.log('changePassword')
        await axios.post(
          this.apiUrl + 'user/changePassword',
          {
            currentPassword: currentPassword,
            newPassword: newPassword
          },
          {
            headers: {
              'sessionId': this.user.sessionId || ''
            }
          }
        )
        alert('הסיסמה שונתה בהצלחה')
      } catch (error) {
        alert(error.response?.data?.message || 'שגיאה בשינוי הסיסמה')
        this.error = error.response?.data?.message || 'שגיאה בשינוי הסיסמה'
        throw error
      } finally {
        this.postAction()
      }
    },

    async forgotPassword(email) {
      this.preAction()
      try {
        console.log('forgotPassword')
        await axios.post(
          this.apiUrl + 'user/forgotPassword',
          {
            email: email
          }
        )
        // Success message will be shown by the component
      } catch (error) {
        alert(error.response?.data?.message || 'שגיאה בשליחת מייל לאיפוס סיסמה')
        this.error = error.response?.data?.message || 'שגיאה בשליחת מייל לאיפוס סיסמה'
        throw error
      } finally {
        this.postAction()
      }
    },

    async resetPassword(resetCode, newPassword) {
      this.preAction()
      try {
        console.log('resetPassword')
        await axios.post(
          this.apiUrl + 'user/resetPassword',
          {
            code: resetCode,
            newPassword: newPassword
          }
        )
        
      } catch (error) {
        alert(error.response?.data?.message || 'שגיאה באיפוס הסיסמה')
        this.error = error.response?.data?.message || 'שגיאה באיפוס הסיסמה'
        throw error
      } finally {
        this.postAction()
      }
    },

    async getUserByEmail(email) {
      this.preAction()
      try {
        console.log('getUserByEmail')
        const response = await axios.post(
          this.apiUrl + 'user/getUserByEmail',
          { email: email },
          {
            headers: {
              'sessionId': this.user.sessionId || ''
            }
          }
        )
        return response.data.user
      } catch (error) {
        alert(error.response?.data?.message || 'שגיאה בחיפוש משתמש')
        this.error = error.response?.data?.message || 'שגיאה בחיפוש משתמש'
        throw error
      } finally {
        this.postAction()
      }
    },

    async transferFactory(factoryId, targetEmail) {
      this.preAction()
      try {
        console.log('transferFactory')
        const response = await axios.post(
          this.apiUrl + 'user/transferFactory',
          {
            factoryId: factoryId,
            targetEmail: targetEmail
          },
          {
            headers: {
              'sessionId': this.user.sessionId || ''
            }
          }
        )
        this.factories = response.data.factories
        // Save to localStorage
        localStorage.setItem('factories', JSON.stringify(this.factories))
        alert('המפעל הועבר בהצלחה')
      } catch (error) {
        alert(error.response?.data?.message || 'שגיאה בהעברת מפעל')
        this.error = error.response?.data?.message || 'שגיאה בהעברת מפעל'
        throw error
      } finally {
        this.postAction()
      }
    },
 
    preAction() {
      this.loaderStore.show()
    },

    postAction() {
      this.loaderStore.hide()
    }
  }
}) 